import { render, staticRenderFns } from "./QuestionTypeList.vue?vue&type=template&id=6ac13e44"
import script from "./QuestionTypeList.vue?vue&type=script&lang=js"
export * from "./QuestionTypeList.vue?vue&type=script&lang=js"
import style0 from "./QuestionTypeList.vue?vue&type=style&index=0&id=6ac13e44&prod&lang=css"
import style1 from "./QuestionTypeList.vue?vue&type=style&index=1&id=6ac13e44&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports